import "reflect-metadata";
import type { IUserStore } from "@whatslly/ui-components/services/UserStore";
import { InjectUserStore } from "@whatslly/ui-components/services/UserStore";
import { Container } from "inversify";
import { UserStore } from "./UserStore";
import { FrontLogger } from "@whatslly/commons/frontLogger/frontLogger";
import type { IFrontLoggerShipping } from "@whatslly/commons/frontLogger/types";
import { FrontLoggerSymbol } from "@whatslly/commons/frontLogger/types";
import { LogShipper } from "./LogShipper";
import { UrlStore } from "./urlStore";
import { IUserManagementDataLayer, UserManagementDataLayerSymbol } from "@whatsllyorg/crm-components/UserManagement";
import { UserManagementAppDataLayer } from "../pages/UsersPage/services/UserManagementAppDataLayer";
import { AdminNotificationsDataLayerSymbol, IAdminNotificationsDataLayer } from "@whatsllyorg/crm-components/TuvisSettings";
import { AdminNotificationsPlatformDataLayer } from "../pages/Settings/NotificationsPage/services/AdminNotificationsPlatformDataLayer";
import { PlatformTuvisMessagingProvider } from "../pages/TuvisMessaging/agent/PlatformTuvisMessagingProvider";
import type { ITuvisMessagingProvider } from "@whatslly/ui-components/Pages/TuvisMessaging/TuvisMessagingProvider";
import { TuvisMessagingProviderSymbol } from "@whatslly/ui-components/Pages/TuvisMessaging/TuvisMessagingProvider";
import type { IStorage } from "@whatslly/commons/storage.constants";
import { InjectStorage } from "@whatslly/commons/storage.constants";
import { container as BGContainer } from "@whatslly/commons/background/di";
import { IndexdDBStorage } from "@whatslly/commons/IndexdDBStorage";
import { LayoutStore } from "@whatsllyorg/crm-components/components/Pages/EditLayoutsPage/store/LayoutStore";
import { MixpanelService } from "@whatslly/commons/mixpanel/MixpanelService";
import type { IMixpanelService } from "@whatslly/commons/mixpanel/types";
import { MixpanelServiceSymbol } from "@whatslly/commons/mixpanel/types";
import { IApiKeysStore } from "../pages/Settings/ApiKeysPage/IApiKeysStore";
import { ApiKeysStore } from "../pages/Settings/ApiKeysPage/ApiKeysStore";
import { IEliteTokenStore } from "../pages/Settings/EliteTokenPage/IEliteTokenStore";
import { EliteTokenStore } from "../pages/Settings/EliteTokenPage/EliteTokenStore";
import type { IDLPStore } from "../pages/Dlp/IDLPStore";
import { InjectDLPStore } from "../pages/Dlp/IDLPStore";
import { DLPStore } from "../pages/Dlp/DLPStore";
import type { ISurveillanceStore } from "../pages/Surveillance/ISurveillanceStore";
import { InjectSurveillanceStore } from "../pages/Surveillance/ISurveillanceStore";
import { SurveillanceStore } from "../pages/Surveillance/SurveillanceStore";
import type { IAccountOrganizationsStore } from "../pages/Account/AccountOrganizations/IAccountOrganizationsStore";
import { InjectAccountOrganizationsStore } from "../pages/Account/AccountOrganizations/IAccountOrganizationsStore";
import { AccountOrganizationsStore } from "../pages/Account/AccountOrganizations/AccountOrganizationsStore";
import type { IOrganizationStore } from "./IOrganizationStore";
import { InjectOrganizationStore } from "./IOrganizationStore";
import { OrganizationStore } from "./OrganizationStore";
import type { ISidecarsStore } from "../pages/Sidecars/ISidecarsStore";
import { InjectSidecarsStore } from "../pages/Sidecars/ISidecarsStore";
import { SidecarsStore } from "../pages/Sidecars/SidecarsStore";
import type { ISidecarPairingStore } from "../pages/Sidecars/ISidecarPairingStore";
import { InjectSidecarPairingStore } from "../pages/Sidecars/ISidecarPairingStore";
import { SidecarPairingStore } from "../pages/Sidecars/SidecarPairingStore";
import { EditColumnsStore } from "@whatslly/ui-components/EditColumns/store/EditColumnsStore";
import type { IEditColumnsStore } from "@whatslly/ui-components/EditColumns/types";
import { EditColumnsStoreSymbol } from "@whatslly/ui-components/EditColumns/types";
export const container = new Container({
  defaultScope: "Singleton",
  autoBindInjectable: true,
  skipBaseClassChecks: true,
});

container.bind<IUserManagementDataLayer>(UserManagementDataLayerSymbol).to(UserManagementAppDataLayer);
container.bind<IUserStore>(InjectUserStore).to(UserStore);
container.bind<IStorage>(InjectStorage).to(IndexdDBStorage);
container.bind(UrlStore).toSelf();
container.bind(FrontLogger).toSelf();
container.bind<IFrontLoggerShipping>(FrontLoggerSymbol).to(LogShipper);
container.bind<IAdminNotificationsDataLayer>(AdminNotificationsDataLayerSymbol).to(AdminNotificationsPlatformDataLayer);
container.bind<ITuvisMessagingProvider>(TuvisMessagingProviderSymbol).to(PlatformTuvisMessagingProvider);
container.bind<IMixpanelService>(MixpanelServiceSymbol).to(MixpanelService);
container.bind(LayoutStore).toSelf();
container.bind<IApiKeysStore>(IApiKeysStore).to(ApiKeysStore);
container.bind<IEliteTokenStore>(IEliteTokenStore).to(EliteTokenStore);
container.bind<IDLPStore>(InjectDLPStore).to(DLPStore);
container.bind<ISurveillanceStore>(InjectSurveillanceStore).to(SurveillanceStore);
container.bind<IAccountOrganizationsStore>(InjectAccountOrganizationsStore).to(AccountOrganizationsStore);
container.bind<IOrganizationStore>(InjectOrganizationStore).to(OrganizationStore);
container.bind<ISidecarsStore>(InjectSidecarsStore).to(SidecarsStore);
container.bind<ISidecarPairingStore>(InjectSidecarPairingStore).to(SidecarPairingStore);
container.bind<IEditColumnsStore>(EditColumnsStoreSymbol).to(EditColumnsStore);
BGContainer.bind<IStorage>(InjectStorage).to(IndexdDBStorage);
BGContainer.bind(FrontLogger).toSelf();
BGContainer.bind<IFrontLoggerShipping>(FrontLoggerSymbol).to(LogShipper);
